import React, { PureComponent } from "react";
import axios from "axios";
import {
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  Button,
  Input,
  Card,
  CardHeader,
  CardBody
} from "reactstrap";
import LoaderSpinner from "../Widgets/LoaderSpinner";
import GeofenceCard from "../../components/GeofenceCard";
import Alert from "../Widgets/Alert";
import withAlertTimeout from "../../HOCs/withAlertTimeout";
import authProtection from "../../HOCs/authProtection";

class Geofences extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      query: "",
      searchResult: null,
      notFound: false,
      isSearching: false,
      rawImage: null,
      previewImage: null,
      success: false,
      failure: false,
      isUpdating: false
    };

    this.onQueryInput = this.onQueryInput.bind(this);
    this.searchGeofences = this.searchGeofences.bind(this);
    this.onCoverUpload = this.onCoverUpload.bind(this);
    this.onCoverPreview = this.onCoverPreview.bind(this);
    this.undoChanges = this.undoChanges.bind(this);
    this.updateGeofenceImage = this.updateGeofenceImage.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  componentDidMount() {
    document.querySelector("#city-input").focus();
  }

  searchGeofences() {
    const { query } = this.state;

    if (query.length) {
      this.setState({
        isSearching: true,
        notFound: false,
        searchResult: false
      });
      axios
        .get(`/api/proxy/v2/geofences?name=${query}`)
        .then(({ data }) => {
          this.setState({ searchResult: data });
          this.setState({ isSearching: false });
        })
        .catch(err => {
          console.log(err);
          this.setState({ notFound: true, isSearching: false });
        });
    }
  }

  undoChanges() {
    this.setState({ rawImage: null, previewImage: null });
    const fileInput = document.querySelector("#geofence-cover-input");

    if (fileInput) {
      fileInput.value = "";
    }
  }

  onKeyPress(e) {
    if (e.charCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      this.searchGeofences();
    }
  }

  updateGeofenceImage() {
    const token = sessionStorage.getItem("token");
    this.setState({ isUpdating: true });
    axios
      .patch(
        `/api/proxy/v2/geofences?slug=${this.state.searchResult.slug}`,
        {
          cover: this.state.rawImage
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(({ data }) => {
        this.props.showSuccess();
        window.scrollTo(0, 0);
        this.setState({ searchResult: null, isUpdating: false });
        this.undoChanges();
      })
      .catch(err => {
        console.log(err);
        this.setState({ isUpdating: false });
        this.props.showFailure();
        window.scrollTo(0, 0);
      });
  }

  onCoverUpload(rawImage) {
    this.setState({ rawImage });
  }

  onCoverPreview(previewImage) {
    this.setState({ previewImage });
  }

  onQueryInput(e) {
    this.setState({ query: e.target.value });
  }

  renderResult() {
    if (this.state.searchResult) {
      return (
        <GeofenceCard
          geofence={this.state.searchResult}
          previewImage={this.state.previewImage}
          onCoverUpload={this.onCoverUpload}
          onCoverPreview={this.onCoverPreview}
          onSave={this.updateGeofenceImage}
          onSelect={this.props.onSelect}
          isPartnership={this.props.isPartnership}
          onCancel={this.undoChanges}
          isUpdating={this.state.isUpdating}
        />
      );
    }
    return null;
  }

  render() {
    return (
      <div className="animated fadeIn">
        {<Alert active={this.props.success} message="Geofence Updated" />}
        {
          <Alert
            type="danger"
            active={this.props.failure}
            message="Something went wrong, please try again"
          />
        }
        <Row>
          <Col xs="12">
            <Card>
              <CardHeader>Search Cities by Name</CardHeader>
              <CardBody>
                <InputGroup>
                  <Input
                    id="city-input"
                    type="search"
                    placeholder="Cambridge, MA"
                    value={this.state.query}
                    onKeyPress={this.onKeyPress}
                    onChange={this.onQueryInput}
                  />
                  <InputGroupAddon
                    className="miami"
                    onClick={this.searchGeofences}
                  >
                    <i className="icon-magnifier" />
                    Search
                  </InputGroupAddon>
                </InputGroup>
              </CardBody>
            </Card>
            {this.state.isSearching && <LoaderSpinner />}
            {this.renderResult()}
            {this.state.notFound && (
              <h3 style={{ textAlign: "center" }}>Geofence not found</h3>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}
export default authProtection(withAlertTimeout(Geofences));



// WEBPACK FOOTER //
// ./src/views/Pages/Geofences.js